// The BE sends `complaint_rate` as the RAW ratio (`(complaints/visits).round(4)`,
// 0.0 when there are no visits) and DELIBERATELY does not clamp it to <=1 (#617):
// a customer can complain more often than they order, so a ratio >1 is a real,
// expected value. The FE renders a whole percentage; the >1 branch is
// load-bearing — do NOT clamp to 100%.
export const complaintRatePercent = (rate: number): string =>
  `${Math.round(rate * 100)}%`
